// onboarding.js — the two-page welcome modal ("Help" reopens it).

function openOnboardingModal() {
  const modal = document.getElementById('onboarding-modal');
  const content = document.getElementById('onboarding-content');
  const page1 = document.querySelector('.page-1');
  const page2 = document.querySelector('.page-2');

  modal.style.display = 'block';
  page1.style.display = 'block';
  page2.style.display = 'none';

  // Replace the buttons to drop any listeners from a previous opening
  const fresh = (id) => { const b = document.getElementById(id); const c = b.cloneNode(true); b.replaceWith(c); return c; };
  const nextBtn = fresh('onboarding-next');
  const backBtn = fresh('onboarding-back');
  const closeBtn = fresh('onboarding-close');
  nextBtn.style.display = 'inline-block';
  backBtn.style.display = 'none';
  closeBtn.style.display = 'none';

  const finish = () => {
    modal.style.display = 'none';
    localStorage.setItem('fishbowl_onboarded', 'true');
    window.removeEventListener('click', handleClose);
  };
  const handleClose = (e) => { if (!content.contains(e.target)) finish(); };

  nextBtn.addEventListener('click', () => {
    page1.style.display = 'none'; page2.style.display = 'block';
    nextBtn.style.display = 'none'; backBtn.style.display = 'inline-block'; closeBtn.style.display = 'inline-block';
  });
  backBtn.addEventListener('click', () => {
    page1.style.display = 'block'; page2.style.display = 'none';
    nextBtn.style.display = 'inline-block'; backBtn.style.display = 'none'; closeBtn.style.display = 'none';
  });
  closeBtn.addEventListener('click', finish);
  setTimeout(() => window.addEventListener('click', handleClose), 200); // avoid closing on the opening click
}

export function initOnboarding() {
  if (localStorage.getItem('fishbowl_onboarded') !== 'true') openOnboardingModal();
  document.getElementById('onboarding-reopen').addEventListener('click', openOnboardingModal);
}
